import React, { Suspense, useRef, useState, useEffect } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import { ViewSGBSApplicationFormData, } from "./data/ViewSGBSApplicationForm.data";
import DataLoader from "../../components/ui/dataLoader/DataLoader";
import Buttons from "../../components/ui/button/Buttons";
import { decryptAESID } from "../../utils/Encryption";
import { useParams, useNavigate } from "react-router-dom";
import { setAllDropDownField, setmainContactFields } from "./utils/dropdownUtils"
import { getFieldParameters, setFieldParameter } from "./utils/setFieldParameter"
import SwalAlert from "../../services/swalService/SwalService";
import { useLazyGetDropDownsForProductsAndServicesQuery, useLazyGetSGBSTaskDetailsByIdQuery, useLazyGetMainContactPersonDetailsForSGBPByRepresentativeIdQuery, useLazyGetMainContactPersonDropdownByCorporateMemberIdQuery, useUpdateViewSGBSApplicationFormMutation, useSendClarificationForSGBPApplicationMutation, useNotifyOrApproveSGBSApplicationMutation, useGetCriteriaBySGBSApplicationIdMutation, useCheckServiceForZCPServiceMutation  } from "../../app/services/productAndService/productAndServiceApi";
import ToastService from "../../services/toastService/ToastService";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import { useAddAuditLogForSGBPApplcation } from "../../utils/AuditLogQuery/addAuditLog";

const ViewSGBSApplicationFormFeature = () => {
  const formRefs = useRef();
  const { id } = useParams();
  const navigate = useNavigate();
  const editID = id ? decryptAESID(id, false) : 0
  const [formData, setFormData] = useState(ViewSGBSApplicationFormData);
  const { success, error, confirm } = SwalAlert();
  const [showClarificationModal, setShowClarificationModal] = useState(false);
  const [clarificationComments, setClarificationComments] = useState("");
  const [isNotify, setIsNotify] = useState(false);
  const [isZCPCategory, setIsZCPCategory] = useState(false)
  const [serviceCategory, setServiceCategory] = useState(0)
  const isInitialZCPCheckRef = useRef(true);
  const [getSGBSTaskDetailsById, { data: taskDetailsData, isLoading: taskDetailsIsLoading, isFetching: taskDetailsIsFetching }] = useLazyGetSGBSTaskDetailsByIdQuery()
  const [productsAndServicesDropdown, { data: productsAndServicesDropDownsData, isLoading: productsAndServicesDropDownsLoading, },] = useLazyGetDropDownsForProductsAndServicesQuery();
  const [mainContactPersonDropdown, { data: mainContactPersonDropdownData, isLoading: mainContactPersonDropdownLoading, },] = useLazyGetMainContactPersonDropdownByCorporateMemberIdQuery();
  const [getMainContactPersonDetails, { data: getMainContactPersonDetailsData, isLoading: getMainContactPersonDetailsLoading, },] = useLazyGetMainContactPersonDetailsForSGBPByRepresentativeIdQuery();
  const [updateViewSGBSApplicationForm, { data: updateViewSGBSApplicationFormResponse, isLoading: updateViewSGBSApplicationFormLoading, },] = useUpdateViewSGBSApplicationFormMutation();
  const [sendClarification, { isSuccess: isSuccessSend, isLoading: isLoadingSend, data: sendClarificationData }] = useSendClarificationForSGBPApplicationMutation();
  const [notifyOrApproveSGBSApplication, { isSuccess: isSuccessNotify, isLoading: isLoadingNotify, data: notifyOrApproveData }] = useNotifyOrApproveSGBSApplicationMutation();
  const [getCriteriaBySGBSApplicationId, { isSuccess: isSuccessCriteria, isLoading: isLoadingCriteria, data: criteriaData }] = useGetCriteriaBySGBSApplicationIdMutation();
  const [checkServiceForZCPService, { isSuccess: checkServiceForZCPServiceIsSuccess, isLoading: checkServiceForZCPServiceIsLoading, data: checkServiceForZCPServiceData, },] = useCheckServiceForZCPServiceMutation();
  const { addAuditLog } = useAddAuditLogForSGBPApplcation(); 
  useEffect(() => {
    if (checkServiceForZCPServiceData && !checkServiceForZCPServiceIsLoading) {
      const canOfferZCP = !!checkServiceForZCPServiceData?.isZCP;
      setIsZCPCategory(canOfferZCP);

      setFormData(prev => {
        const isInitialLoad = isInitialZCPCheckRef.current;
        const nextAreYouZCP = isInitialLoad ? prev.initialState.areYouZCP : (canOfferZCP ? prev.initialState.areYouZCP : "no");
        const isZCPYes = canOfferZCP && nextAreYouZCP === "yes";

        let updatedFormFields = toggleFieldVisibility(
          prev.formFields, "areYouZCP", canOfferZCP, "col-lg-12 col-12 mb-4 mt-2 x-position"
        );
        updatedFormFields = toggleFieldVisibility(
          updatedFormFields, "zcpCategories", isZCPYes, "col-lg-6 col-md-6 col-sm-12 mb-3"
        );

        return {
          ...prev,
          formFields: updatedFormFields,
          initialState: {
            ...prev.initialState,
            serviceCategory: serviceCategory,
            areYouZCP: nextAreYouZCP,
          },
        };
      });

      isInitialZCPCheckRef.current = false;
    }
  }, [checkServiceForZCPServiceData, checkServiceForZCPServiceIsLoading]);

  useEffect(() => {
    if (editID > 0) {
      productsAndServicesDropdown();
      getSGBSTaskDetailsById(editID);
    }
  }, [editID])

  useEffect(() => {
    if (productsAndServicesDropDownsData && !productsAndServicesDropDownsLoading) {
      setAllDropDownField(productsAndServicesDropDownsData);
    }
  }, [productsAndServicesDropDownsData, productsAndServicesDropDownsLoading])

useEffect(() => {
  if (taskDetailsData && !taskDetailsIsLoading) {
    const req = { SubCategopryL1Id: taskDetailsData?.sgbsServiceCategoryId };
    if (!taskDetailsData?.criteriaId) getCriteriaBySGBSApplicationId(req);
    if (taskDetailsData?.sgbsServiceCategoryId > 0) {
      checkServiceForZCPService({ id: taskDetailsData?.sgbsServiceCategoryId });
    }
    mainContactPersonDropdown(taskDetailsData.sgbcCorporateMemberId);
    setServiceCategory(taskDetailsData?.sgbsServiceCategoryId);

    const fieldValues = getFieldParameters(taskDetailsData);
    setFormData(prev => ({
      ...prev,
      initialState: { ...prev.initialState, ...fieldValues },
    }));
  }
}, [taskDetailsData, taskDetailsIsLoading]);

  useEffect(() => {
    if (!mainContactPersonDropdownLoading && mainContactPersonDropdownData) {
      setmainContactFields(mainContactPersonDropdownData, setFormData);
    }
  }, [mainContactPersonDropdownLoading, mainContactPersonDropdownData]);

  useEffect(() => {
    if (!isLoadingCriteria && criteriaData) {
      let updatedFormData = { ...formData };
      updatedFormData = { ...updatedFormData.initialState, criteriaSelected: criteriaData?.criteriaId || null, }
      setFormData(prev => ({ ...prev, initialState: { ...prev.initialState, ...updatedFormData } }));
    }
  }, [isSuccessCriteria, isLoadingCriteria, criteriaData]);

  const toggleFieldVisibility = (formFields, fieldId, show, baseCss) => {
    return formFields.map(field => {
      if (field.id === fieldId) {
        return {
          ...field,
          style: { ...field.style, containerCss: show ? baseCss : `${baseCss} d-none` },
          validation: show ? [{ type: "require" }] : [],
        };
      }
      return field;
    });
  };


  const handleFormFieldChange = (dataField, value) => {
    let form = { ...formData };
    form.initialState = { ...form.initialState };
    const selectedValue = value?.value ?? null;
    setServiceCategory(selectedValue)

    if (dataField === "mainContactPerson") {
      setFormData(prev => ({ ...prev, initialState: { ...prev.initialState, mainContactPerson: selectedValue } }));
      if (selectedValue) {
        getMainContactPersonDetails(selectedValue);
      }
    }

    else if (dataField === "serviceCategory") {
      if (selectedValue) {
        let req = { Id: selectedValue };
        checkServiceForZCPService(req);
      }

      setFormData(prev => {
        const newAreYouZCP = isZCPCategory ? prev.initialState.areYouZCP : "no";
        const isZCPYes = isZCPCategory && newAreYouZCP === "yes";

        let updatedFormFields = toggleFieldVisibility(
          prev.formFields, "areYouZCP", isZCPCategory, "col-lg-12 col-12 mb-4 mt-2 x-position"
        );
        updatedFormFields = toggleFieldVisibility(
          updatedFormFields, "zcpCategories", isZCPYes, "col-lg-6 col-md-6 col-sm-12 mb-3"
        );

        return {
          ...prev,
          formFields: updatedFormFields,
          initialState: {
            ...prev.initialState,
            serviceCategory: selectedValue,
            areYouZCP: newAreYouZCP,
          },
        };
      });

      if (selectedValue) {
        getMainContactPersonDetails(selectedValue);
      }
    }
    else if (dataField === "areYouZCP") {
      const isZCPYes = value === "yes";

      setFormData(prev => {
        const updatedFormFields = toggleFieldVisibility(
          prev.formFields, "zcpCategories", isZCPYes, "col-lg-6 col-md-6 col-sm-12 mb-3"
        );
        return {
          ...prev,
          formFields: updatedFormFields,
          initialState: {
            ...prev.initialState,
            areYouZCP: value,
            zcpCategories: isZCPYes ? prev.initialState.zcpCategories : null,
          },
        };
      });
    }
    else {
      setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...form.initialState, [dataField]: value, }, }));
    }
  };

  useEffect(() => {
    if (!getMainContactPersonDetailsLoading && getMainContactPersonDetailsData) {
      setFormData(prev => ({
        ...prev,
        initialState: {
          ...prev.initialState,
          mainContactPhoneCountryCode: getMainContactPersonDetailsData?.contactNumberCountryId,
          mainContactPhone: getMainContactPersonDetailsData?.contactNumber,
          mainContactEmailAddress: getMainContactPersonDetailsData?.email,
        }
      }));
    }
  }, [getMainContactPersonDetailsLoading, getMainContactPersonDetailsData]);

  useEffect(() => {
    if (!updateViewSGBSApplicationFormLoading && updateViewSGBSApplicationFormResponse) {
      if (!updateViewSGBSApplicationFormResponse.hasError) {
        !isNotify && success("View SGBS Application is updated!");
        setIsNotify(false);
      }
    }
  }, [updateViewSGBSApplicationFormLoading, updateViewSGBSApplicationFormResponse]);

  useEffect(() => {
    if (!checkServiceForZCPServiceIsLoading && checkServiceForZCPServiceData) {
      setIsZCPCategory(checkServiceForZCPServiceData?.isZCP);
    }
  }, [checkServiceForZCPServiceIsLoading, checkServiceForZCPServiceData]);

  const handleSubmit = () => {
    let form = formRefs.current.getFormData();
    if (!form) {
      error("Please fill in all mandatory fields to continue.", "");
      return
    }
    let req = {
      sgbcCorporateMemberId: taskDetailsData?.sgbcCorporateMemberId || null,
      sgbcCorporateRepresentativeId: form?.mainContactPerson || null,
      isSGBS: true,
      sgbsServiceCategoryId: form?.serviceCategory?.value || form?.serviceCategory || null,
      sgbpProductInformationId: editID,
      criteriaId: form?.criteriaSelected?.value || form?.criteriaSelected || null,
      ZeroCapitalPartnerId: form?.zcpCategories?.value || form?.zcpCategories || null,
      IsZCP: form?.areYouZCP == 'yes' ? true : false,
    }
    updateViewSGBSApplicationForm(req);
  }  
  const handleSendClarification = () => {
    let req = {
      SGBPProductInformationId: editID,
      SGBCCorporateMemberId: taskDetailsData?.sgbcCorporateMemberId,
      notes: clarificationComments
    }
    sendClarification(req);
  }

  const handleNofityApprove = () => {
    setIsNotify(true);
    let req = {
      SGBPProductInformationId: editID,
    }
    notifyOrApproveSGBSApplication(req);
  }

  useEffect(() => {
    if (isSuccessSend && sendClarificationData) {
      ToastService.success("Clarification sent successfully!");
      addAuditLog({SGBPSApplicationId:editID, AuditLogDescription: clarificationComments? "Clarification Sent (Comment): " + clarificationComments: "Clarification Sent For SGBS Application", TriggredTimeStatusId:taskDetailsData?.statusId });
      setShowClarificationModal(false);
      setClarificationComments("");
      navigate(`/viewApplicationTaskList`);
    }
  }, [isLoadingSend, isSuccessSend, sendClarificationData]);

  useEffect(() => {
    if (!isLoadingNotify && isSuccessNotify && notifyOrApproveData) {
      ToastService.success("SGBS Application is notified/approved successfully!");
      handleSubmit();
      addAuditLog({SGBPSApplicationId:editID, AuditLogDescription: "SGBS Application Notified For Self Evaluation", TriggredTimeStatusId:taskDetailsData?.statusId });
      handleBack();
      getSGBSTaskDetailsById(editID);
    }
  }, [isLoadingNotify, isSuccessNotify, notifyOrApproveData])

  const handleBack = () => {
    navigate(`/viewApplicationTaskList`);
  }

  return (
    <Suspense fallback={<DataLoader />}>
      {mainContactPersonDropdownData ?
        <>
          <div className="row">
            <FormCreator ref={formRefs}
              {...formData}
              onFormFieldValueChange={handleFormFieldChange}
            />
          </div>

          <div className="sgbp-button-section">
            <Buttons
              buttonText="Back"
              buttonTypeClassName="back-btn"
              onClick={handleBack}
            />
            <Buttons
              buttonText="Save"
              buttonTypeClassName="save-btn"
              onClick={handleSubmit}
              isDisable={[5].includes(taskDetailsData?.statusId)}
            />
            <Buttons
              buttonText="Send Clarification"
              buttonTypeClassName="send-btn"
              onClick={() => { setShowClarificationModal(true) }}
               isDisable={[3, 5].includes(taskDetailsData?.statusId)}
            // onClick={handleSearch}
            />
            <Buttons
              buttonText="Notify/Approve"
              buttonTypeClassName="notify-btn"
              onClick={handleNofityApprove}
              isLoading={isLoadingNotify}
              isDisable={[3, 5].includes(taskDetailsData?.statusId)}
            />
          </div>
        </> :
        <DataLoader />
      }
      {showClarificationModal && <CenterModel
        show={showClarificationModal}
        handleClose={() => (setShowClarificationModal(false), setClarificationComments(""))}
        modelTitle="Send Clarifications"
      >
        <textarea
          className="form-control mt-2"
          rows="4"
          placeholder=""
          value={clarificationComments}
          onChange={(e) => setClarificationComments(e.target.value)}
        />
        <div className="d-flex justify-content-between gap-2 mt-4">
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="black-btn"
            onClick={() => (setShowClarificationModal(false), setClarificationComments(""))}
            isDisable={isLoadingSend}
          />
          <Buttons
            buttonText="Send"
            buttonTypeClassName="success-btn"
            onClick={handleSendClarification}
            isLoading={isLoadingSend}
            isDisable={isLoadingSend}
          />
        </div>
      </CenterModel>}
    </Suspense>
  );
};

export default ViewSGBSApplicationFormFeature;
